import { LOGO_URL, CONTACT, DISCLAIMER } from "@/data/content";
import { Linkedin, Instagram, Facebook, Phone, Mail, MapPin } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="relative z-10 border-t border-white/10 bg-navy-deep">
      <div className="mx-auto max-w-7xl px-6 py-20 lg:py-28">
        <div className="grid gap-14 md:grid-cols-12">
          <div className="md:col-span-5">
            {/* Logo */}
            <img src={LOGO_URL} alt="Matlock Advisory Group" className="h-20 sm:h-24 w-auto" />
            <p className="mt-6 max-w-sm text-sm leading-relaxed text-white/55">
              A financial coordination and consulting partner for CRNAs and high-income 1099 medical
              professionals — built around one personalized Financial Operating System.
            </p>
            <div className="mt-6 flex gap-3">
              {/* Social media links — TODO: replace href with real profiles */}
              <a href={CONTACT.socials.linkedin} data-testid="footer-linkedin" aria-label="LinkedIn" className="grid h-10 w-10 place-items-center rounded-sm border border-white/15 text-white/70 hover:border-gold hover:text-gold transition-colors duration-300">
                <Linkedin size={18} />
              </a>
              <a href={CONTACT.socials.instagram} data-testid="footer-instagram" aria-label="Instagram" className="grid h-10 w-10 place-items-center rounded-sm border border-white/15 text-white/70 hover:border-gold hover:text-gold transition-colors duration-300">
                <Instagram size={18} />
              </a>
              <a href={CONTACT.socials.facebook} data-testid="footer-facebook" aria-label="Facebook" className="grid h-10 w-10 place-items-center rounded-sm border border-white/15 text-white/70 hover:border-gold hover:text-gold transition-colors duration-300">
                <Facebook size={18} />
              </a>
            </div>
          </div>

          <div className="md:col-span-3">
            <p className="text-xs uppercase tracking-[0.2em] text-gold">Navigate</p>
            <ul className="mt-5 space-y-3 text-sm text-white/70">
              {[["The System", "#system"], ["Services", "#services"], ["Who We Serve", "#serve"], ["Process", "#process"], ["About", "#about"], ["Contact", "#contact"]].map(([label, href]) => (
                <li key={href}>
                  <a href={href} className="hover:text-white transition-colors duration-300">{label}</a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <p className="text-xs uppercase tracking-[0.2em] text-gold">Contact</p>
            <ul className="mt-5 space-y-4 text-sm text-white/70">
              {/* Contact information — replace with real details */}
              <li className="flex items-center gap-3"><Phone size={16} className="text-gold" /><a href={`tel:${CONTACT.phone}`} className="hover:text-white transition-colors duration-300">{CONTACT.phone}</a></li>
              <li className="flex items-center gap-3"><Mail size={16} className="text-gold" /><a href={`mailto:${CONTACT.email}`} className="hover:text-white transition-colors duration-300">{CONTACT.email}</a></li>
              <li className="flex items-center gap-3"><MapPin size={16} className="text-gold" />{CONTACT.address}</li>
            </ul>
          </div>
        </div>

        {/* Compliance disclaimer */}
        <div className="mt-16 rounded-sm border border-white/10 bg-white/[0.03] p-6">
          <p className="text-xs uppercase tracking-[0.2em] text-white/40">Important Disclosures</p>
          <p data-testid="footer-disclaimer" className="mt-3 text-xs leading-relaxed text-white/50">{DISCLAIMER}</p>
        </div>

        <div className="mt-10 flex flex-col gap-4 border-t border-white/10 pt-8 text-xs text-white/40 md:flex-row md:items-center md:justify-between">
          <p>© {new Date().getFullYear()} Matlock Advisory Group, Inc. All rights reserved.</p>
          <div className="flex gap-6">
            {/* TODO: add Privacy Policy & Terms of Use pages */}
            <a href="#" className="hover:text-white transition-colors duration-300">Privacy Policy</a>
            <a href="#" className="hover:text-white transition-colors duration-300">Terms of Use</a>
            <a href="#" className="hover:text-white transition-colors duration-300">Client Disclosures</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
